import { COMBAT, PHYSICS } from '@/types';

export const SIM_TIMESTEP_MS = 16;

export const PLAYER_WIDTH = 32;
export const PLAYER_HEIGHT = 32;

export const COIN_WIDTH = 30;
export const COIN_HEIGHT = 30;

export const GOAL_WIDTH = 32;
export const GOAL_HEIGHT = 64;

export const REQUIRED_COINS_TO_LAUNCH = 3;

export const JUMP_BUFFER_TICKS = Math.trunc(PHYSICS.JUMP_BUFFER_TIME / SIM_TIMESTEP_MS);
export const COYOTE_TICKS = Math.trunc(PHYSICS.COYOTE_TIME / SIM_TIMESTEP_MS);

export const PLAYER_START_LEFT = { x: 20, y: 518 };

export const MAX_HEALTH = COMBAT.PLAYER_MAX_HEALTH;

export const PLAYER_SPEED = PHYSICS.PLAYER_SPEED;
export const PLAYER_JUMP_FORCE = PHYSICS.PLAYER_JUMP_FORCE;
export const TERMINAL_VELOCITY = PHYSICS.TERMINAL_VELOCITY;
export const GRAVITY = PHYSICS.GRAVITY;
export const GRAVITY_ASCENT_TICK_INTERVAL = PHYSICS.GRAVITY_ASCENT_TICK_INTERVAL;
export const GRAVITY_DESCENT_TICK_INTERVAL = PHYSICS.GRAVITY_DESCENT_TICK_INTERVAL;

export const JETPACK_MAX_FUEL = PHYSICS.JETPACK_MAX_FUEL;
export const JETPACK_THRUST_FORCE = PHYSICS.JETPACK_THRUST_FORCE;
export const JETPACK_THRUST_TICK_INTERVAL = PHYSICS.JETPACK_THRUST_TICK_INTERVAL;
export const JETPACK_MAX_ASCENT_SPEED = PHYSICS.JETPACK_MAX_ASCENT_SPEED;
export const JETPACK_FUEL_REGEN_TICK_INTERVAL = PHYSICS.JETPACK_FUEL_REGEN_TICK_INTERVAL;

export const LASER_DAMAGE = COMBAT.LASER_DAMAGE;
export const LASER_SPEED = COMBAT.LASER_SPEED;
export const LASER_WIDTH = COMBAT.LASER_WIDTH;
export const LASER_HEIGHT = COMBAT.LASER_HEIGHT;
export const LASER_COOLDOWN_TICKS = COMBAT.LASER_COOLDOWN_TICKS;
export const LASER_LIFETIME_TICKS = COMBAT.LASER_LIFETIME_TICKS;

export const STAR_FIELD = [
  { x: 20, y: 24, size: 2, color: '#f5fbff' },
  { x: 64, y: 70, size: 2, color: '#dce9ff' },
  { x: 120, y: 38, size: 3, color: '#ffffff' },
  { x: 170, y: 94, size: 2, color: '#e3efff' },
  { x: 230, y: 48, size: 2, color: '#f5fbff' },
  { x: 282, y: 24, size: 3, color: '#f9fcff' },
  { x: 330, y: 78, size: 2, color: '#dce9ff' },
  { x: 390, y: 58, size: 2, color: '#f5fbff' },
  { x: 430, y: 20, size: 2, color: '#ffffff' },
  { x: 490, y: 86, size: 3, color: '#e3efff' },
  { x: 540, y: 42, size: 2, color: '#f5fbff' },
  { x: 600, y: 65, size: 2, color: '#dce9ff' },
  { x: 660, y: 30, size: 2, color: '#ffffff' },
  { x: 720, y: 76, size: 3, color: '#f5fbff' },
  { x: 780, y: 50, size: 2, color: '#e3efff' },
  { x: 840, y: 26, size: 2, color: '#ffffff' },
  { x: 900, y: 74, size: 2, color: '#dce9ff' },
  { x: 960, y: 44, size: 3, color: '#f5fbff' },
] as const;
